"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingLedgerSourceType = exports.BillingTierName = exports.NonComplianceShipmentStatus = exports.NonComplianceShipmentSummaryDataStatus = exports.NonComplianceProductStatus = exports.NonComplianceCaseStatus = exports.AsnType = exports.NonComplianceCaseIdPrefix = void 0;
var NonComplianceCaseIdPrefix;
(function (NonComplianceCaseIdPrefix) {
    NonComplianceCaseIdPrefix["OTHER_SUBMISSION"] = "S";
    NonComplianceCaseIdPrefix["UNKNOWN_BARCODE_CASE"] = "B";
    NonComplianceCaseIdPrefix["MISSING_BARCODE_CASE"] = "M";
    NonComplianceCaseIdPrefix["UNEXPECTED_SKU_CASE"] = "U";
    NonComplianceCaseIdPrefix["INVALID_LOT_EXPIRY"] = "I";
    NonComplianceCaseIdPrefix["DAMAGED_PRODUCT"] = "D";
})(NonComplianceCaseIdPrefix = exports.NonComplianceCaseIdPrefix || (exports.NonComplianceCaseIdPrefix = {}));
var AsnType;
(function (AsnType) {
    AsnType["TRANSFER"] = "TRANSFER";
    AsnType["REGULAR"] = "REGULAR";
})(AsnType = exports.AsnType || (exports.AsnType = {}));
var NonComplianceCaseStatus;
(function (NonComplianceCaseStatus) {
    NonComplianceCaseStatus["CREATED"] = "CREATED";
    NonComplianceCaseStatus["RESOLVED"] = "RESOLVED";
    NonComplianceCaseStatus["COMPLETED"] = "COMPLETED";
})(NonComplianceCaseStatus = exports.NonComplianceCaseStatus || (exports.NonComplianceCaseStatus = {}));
var NonComplianceProductStatus;
(function (NonComplianceProductStatus) {
    NonComplianceProductStatus["CREATED"] = "CREATED";
    NonComplianceProductStatus["SUPPORT_CONTACTED"] = "SUPPORT_CONTACTED";
    NonComplianceProductStatus["RESOLVED"] = "RESOLVED";
    NonComplianceProductStatus["COMPLETED"] = "COMPLETED";
})(NonComplianceProductStatus = exports.NonComplianceProductStatus || (exports.NonComplianceProductStatus = {}));
var NonComplianceShipmentSummaryDataStatus;
(function (NonComplianceShipmentSummaryDataStatus) {
    NonComplianceShipmentSummaryDataStatus["CREATED"] = "CREATED";
    NonComplianceShipmentSummaryDataStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
    NonComplianceShipmentSummaryDataStatus["SUPPORT_CONTACTED"] = "SUPPORT_CONTACTED";
    NonComplianceShipmentSummaryDataStatus["RESOLVED"] = "RESOLVED";
    NonComplianceShipmentSummaryDataStatus["COMPLETED"] = "COMPLETED";
})(NonComplianceShipmentSummaryDataStatus = exports.NonComplianceShipmentSummaryDataStatus || (exports.NonComplianceShipmentSummaryDataStatus = {}));
var NonComplianceShipmentStatus;
(function (NonComplianceShipmentStatus) {
    NonComplianceShipmentStatus["NORMAL"] = "NORMAL";
    NonComplianceShipmentStatus["ACTION_NEEDED"] = "ACTION_NEEDED";
})(NonComplianceShipmentStatus = exports.NonComplianceShipmentStatus || (exports.NonComplianceShipmentStatus = {}));
var BillingTierName;
(function (BillingTierName) {
    BillingTierName["REPEAT"] = "Repeat";
    BillingTierName["STANDARD"] = "Standard";
    BillingTierName["CRITICAL"] = "Critical";
})(BillingTierName = exports.BillingTierName || (exports.BillingTierName = {}));
var BillingLedgerSourceType;
(function (BillingLedgerSourceType) {
    BillingLedgerSourceType["NON_COMPLIANCE_PRODUCT_ID"] = "NON_COMPLIANCE_PRODUCT_ID";
    BillingLedgerSourceType["MISSING_BARCODE_CASE_ID"] = "MISSING_BARCODE_CASE_ID";
})(BillingLedgerSourceType = exports.BillingLedgerSourceType || (exports.BillingLedgerSourceType = {}));
//# sourceMappingURL=NonComplianceResponses.js.map